<template>
    <v-tab-item class="fill-height">

        <div class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16">미팅진행 공고 선택</h3>
            <p class="page-text--lg grey-6--text">면접을 진행할 공고를 선택한 후 다음 단계로 넘어가 주세요.</p>
        </div>
        <v-sheet v-scroll.self="loadMore" class="w-100 scroll-primary pr-10" style="overflow-y: auto;" :style="$vuetify.breakpoint.mdAndUp ? 'max-height: 460px;' : 'max-height: 320px;'">
            <div class="v-cards">
                <v-card v-for="item in items" :key="item._id" rounded="lg" outlined class="recruitment-item" @click="$emit('input', item)">
                    <div class="pa-20 pa-md-24">
                        <v-row align="center" class="row--large">
                            <v-col cols="auto">
                                <v-simple-checkbox :value="value?._id == item?._id" color="primary" @click="$emit('input', item)" />
                            </v-col>
                            <v-col class="recruitment-item__contents">
                                <h5 class="page-text--lg font-wieght-medium mb-8 mb-lg-16">
                                    {{ item?.subject }}
                                </h5>
                                <v-chip-group class="mb-4">
                                    <v-chip v-for="text in item?.qualification?.workExperience?.texts || []" :key="text" small outlined color="grey-d">
                                        <span class="grey-6--text">
                                            {{ text }}
                                        </span>
                                    </v-chip>
                                </v-chip-group>
                                <p class="page-text grey-6--text ellip mb-8 mb-lg-16">
                                    {{ item?.summary }}
                                </p>
                                <recruitment-view-application v-bind="item" />
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </div>
        </v-sheet>
        <v-fade-transition>
            <v-overlay v-show="loading" absolute color="white">
                <v-progress-circular color="black" size="100" width="5" indeterminate />
            </v-overlay>
        </v-fade-transition>
        <div class="v-btn-group">
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('next')"><span>다음으로</span></v-btn>
        </div>

        <!-- <v-layout column align-center fill-height style="overflow-y: hidden">
            <v-card-title class="font-size-26 font-size-md-30 font-size-lg-36">미팅 진행 공고 선택</v-card-title>
            <v-card-subtitle class="page-text--lg pt-16 pb-40 grey-6--text">면접을 진행할 공고를 선택한 후 다음 단계로 넘어가 주세요.</v-card-subtitle>
            <v-card-text class="d-flex flex-column" style="position: relative; flex: 0 1 auto; overflow-y: hidden">
                <v-sheet style="overflow-y: auto" class="px-10" v-scroll.self="loadMore">
                    <v-card v-for="item in items" :key="item._id" class="my-30 rounded-lg" @click="$emit('input', item)">
                        <v-row align="center" no-gutters class="pa-24">
                            <v-col cols="auto" md="1">
                                <v-simple-checkbox :value="value?._id == item?._id" color="primary" @click="$emit('input', item)" />
                            </v-col>
                            <v-col>
                                <v-card-title class="pa-0 font-size-16 font-size-lg-20"> {{ item?.subject }} </v-card-title>
                                <v-chip-group class="px-16">
                                    <v-chip v-for="text in item?.qualification?.workExperience?.texts || []" :key="text" small outlined>{{ text }}</v-chip>
                                </v-chip-group>
                                <v-card-text class="pa-0 page-text">
                                    {{ item?.summary }}
                                </v-card-text>
                                <v-card-subtitle class="pa-0">
                                    <recruitment-view-application v-bind="item" />
                                </v-card-subtitle>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-sheet>
                <v-fade-transition>
                    <v-overlay v-show="loading" absolute color="white">
                        <v-progress-circular color="black" size="100" width="5" indeterminate />
                    </v-overlay>
                </v-fade-transition>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn outlined @click="$emit('prev')"> 이전으로</v-btn>
                <v-btn color="primary" @click="$emit('next')"> 다음으로 </v-btn>
            </v-card-actions>
        </v-layout> -->
    </v-tab-item>
</template>

<script>
import api from "@/api";

import RecruitmentViewApplication from "@/components/dumb/recruitment-view-application.vue";

export default {
    components: {
        RecruitmentViewApplication,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // meeting.recruitment
    },
    data: () => ({
        recruitments: [],

        page: 1,
        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        items() {
            return this.recruitments.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        hasMoreToLoad() {
            return this.recruitments.length < this.summary.totalCount;
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        page() {
            this.search();
        },
    },
    methods: {
        async search() {
            if (this.loading) return;

            this.loading = true;
            try {
                let { skip, limit } = this;
                const { summary, recruitments } = await api.v1.company.recruitments.gets({
                    headers: { skip, limit },
                });

                this.summary = summary;
                this.recruitments = this.recruitments.concat(recruitments);
            } finally {
                this.loading = false;
            }
        },
        async loadMore({ target: { clientHeight, scrollHeight, scrollTop } }) {
            const scrollBottom = scrollHeight - clientHeight - scrollTop;
            if (scrollBottom < 100 && this.hasMoreToLoad) {
                this.page += 1;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.recruitment-item{
    &__contents{
        max-width: calc(100% - 34px);
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .recruitment-item{
        &__contents{
            max-width: calc(100% - 64px);
        }
    }
}
@media (min-width:1200px){
}

</style>
